import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { FC } from 'react';
import { useDarkMode, useMediaUp } from '../../../hooks'
import Image from 'next/image';
import { lines, mobileLines } from '../../../images/gpm';

interface InterestedBlockProps {
  title: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    marginTop: 70,
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : theme.palette.secondary.dark),
    fontSize: 20,
    fontWeight: 500,
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  link: {
    boxShadow: 'none',
    borderRadius: '0 10px',
    padding: '14px 35px',
    textTransform: 'none',
    fontSize: 15,
    lineHeight: 1,
    fontWeight: 500,
    color: '#0061E5',
    border: '2px solid #0061E5',
    backgroundColor: 'transparent',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#0061E5',
      color: '#ffffff',
    },
  }
}));

const InterestedBlock: FC<InterestedBlockProps> = (props) => {
  const { title } = props;
  const { isDarkMode } = useDarkMode();
  const classes = useStyles(isDarkMode);
  const isSmallUp = useMediaUp('sm');

  return (
    <Container maxWidth={false} fixed>
      <Grid justifyContent="space-between" alignItems={'center'} container>
        <Grid xs={12} item>
          <Typography className={classes.title}>{title}</Typography>
          <Box display={'flex'} justifyContent={'center'} mt={3} mb={5}>
            <a className={classes.link} href={'https://gpmgis.com/'} target="_blank" rel="noopener noreferrer">
              {'Visit website'}
            </a>
          </Box>
        </Grid>
      </Grid>
      <Grid xs={12} item>
        <Box display={'flex'} justifyContent={'center'}>
          <Image src={isSmallUp ? lines : mobileLines} height={isSmallUp ? 354 : 133} width={isSmallUp ? 1440 : 375} />
        </Box>
      </Grid>
    </Container>
  );
};

export default InterestedBlock;
